// images:
// https://pixabay.com/en/people-girls-women-students-2557396/
// https://pixabay.com/en/workplace-team-business-meeting-1245776/
// https://unsplash.com/photos/cw-cj_nFa14
// https://pixabay.com/en/audience-speech-speaker-1677028/
// https://pixabay.com/en/eating-restaurant-food-meal-lunch-601581/
// https://unsplash.com/photos/XCo6jAqksWg
// https://commons.wikimedia.org/wiki/File:Yoga_Class_at_a_Gym4.JPG
// https://pixabay.com/en/theatre-aysen-chorus-2206583/
export default {
  general: {
    appTitle: 'biznisNET – expand abroad',
    gaTrackingId: 'UA-113223352-2', // TODO
  },
  navigation: {
    labels: {
      about: 'About',
      program: 'Program',
      venue: 'Contact',
      sponsors: 'Partners',
      chat: 'Chat',
      reportProblem: 'Report a problem',
    },
    icons: {
      about: 'about',
      program: 'program',
      track: 'presentation',
      venue: 'contact',
      sponsors: 'partners',
      chat: 'chat',
      reportProblem: 'problem',
    },
    items: ['program', 'chat', 'venue', 'about', 'sponsors', 'reportProblem'],
  },
  pages: {
    about: {
      text: require('./about/text').default,
      gallery: [],
    },
    program: {
      text: require('./program/text').default,
    },
    sponsors: {
      sections: [require('./sponsors/partners').default],
    },
    venue: {
      mapImage: require('./resources/map-min.png'),
      mapLink:
        'https://www.google.com/maps/place/Twin+City+A/@48.146164,17.1169968,15.25z/data=!4m5!3m4!1s0x476c893890b7d0b5:0x2e3900d3d8d914be!8m2!3d48.1450876!4d17.1240031',
      text: require('./venue/text').default,
    },
    reportProblem: {},
  },
  data: {
    tracks: require('./data/tracks').default,
    sessions: require('./data/sessions').default,
    presentations: require('./data/presentations').default,
    presenters: require('./data/presenters').default,
  },
  addons: {
    feedback: require('./addons/feedback').default,
    socialShare: require('./addons/socialShare').default,
    chat: require('./addons/chat').default,
  },
  intl: {
    preferredLocales: ['EN-en', 'SK-sk', 'CZ-cz'],
    messages: {
      ...require('../../intl/messages/en').default,
      'PresentationDetail.tab.chat': 'Questions',
    },
  },
  // theme will be deep-merged with default theme
  // see theme properties: http://www.material-ui.com/#/customization/themes
  // `custom` key contains addintional theme keys (see default theme in `theme.js`)
  theme: {
    custom: {
      images: {
        logo: require('./resources/logo.png'),
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/index.js